import Image from 'next/image'
import styles from './AlternatingContent.module.scss'

export default function AlternatingContent(props) {
  const {
    alternatingSubheading,
    alternatingHeading,
    alternatingContentImageFullWidth,
    alternatingTextContent,
    alternatingIcon,
    alternatingImage,
    imageRightOrLeft
  } = props.fields

  const layoutClass = imageRightOrLeft === 'Left' ? styles.leftLayout : styles.rightLayout
  const imageSize = alternatingContentImageFullWidth === 'Yes' ? styles.FullWidthImage : ''

  return (
    <div className="container">
      <div className={styles.AlternatingContentSection} data-aos="fade-up" data-cy="alternating-content-section">
        <div className={`${styles.AlternatingContentWrapper} ${layoutClass} ${imageSize}`}>
          <div className={styles.WYSIWYGWrapper}>
            {alternatingIcon?.node?.sourceUrl && (
              <Image
                className={styles.icon}
                src={alternatingIcon.node.sourceUrl}
                alt={alternatingIcon.node.altText || ''}
                width={100}
                height={100}
                sizes="100px"
              />
            )}
            {alternatingSubheading && (
              <p className={styles.subheading} data-cy="alternating-content-subheading">
                {alternatingSubheading}
              </p>
            )}
            {alternatingHeading && (
              <h2 className={styles.heading} data-cy="alternating-content-title">
                {alternatingHeading}
              </h2>
            )}
            <div
              className={styles.WYSIWYG}
              data-cy="alternating-content-paragraph"
              dangerouslySetInnerHTML={{
                __html: alternatingTextContent
              }}
            ></div>
          </div>

          <div className={styles.image}>
            {alternatingImage?.node?.sourceUrl && (
              <Image
                className={styles.AlternatingImage}
                data-cy="alternating-content-image"
                src={alternatingImage.node.sourceUrl}
                alt={alternatingImage.node.altText || ''}
                width={1000}
                height={1000}
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
